function asList(v) {
  return Array.isArray(v) ? v : [];
}

function collectButtons(list, acc) {
  const arr = asList(list);
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    if (!item) continue;
    if (item.component === "v-button") {
      acc.push(item);
    }
    if (item.propValue && Array.isArray(item.propValue)) {
      collectButtons(item.propValue, acc);
    }
  }
  return acc;
}

function buttonNameOf(comp) {
  if (!comp) return "";
  return comp.propValue || (comp.style && comp.style.alias) || comp.label || "按钮";
}

function pageNameFromStore(pageId, canvasAllData, pageOptions) {
  const id = pageId != null ? String(pageId) : "";
  const opts = asList(pageOptions);
  const opt = opts.find((p) => String(p.value) === id);
  if (opt && opt.label) return opt.label;
  let pages = canvasAllData;
  if (typeof pages === "string") {
    try {
      pages = JSON.parse(pages);
    } catch (e) {
      pages = null;
    }
  }
  const page = pages && pages[id];
  const first = Array.isArray(page) ? page[0] : null;
  return (first && first.style && first.style.pageName) || ("页面 " + id);
}

export function networkBindCount(comp) {
  if (!comp) return 0;
  const n = comp.networkConfig || {};
  const a = (comp.activeDetectionConfig && comp.activeDetectionConfig.bindDirectives) || [];
  return (
    asList(n.directives).length +
    asList(n.directives2).length +
    asList(n.sliderList).length +
    asList(a).length
  );
}

export function eventBindCount(comp) {
  if (!comp || !comp.events) return 0;
  const e = comp.events;
  let n = 0;
  n += asList(e.mutuallyEvent).length;
  n += asList(e.jumpEvent).length;
  n += asList(e.pressEvent).length;
  n += asList(e.pressAgainEvent).length;
  if (e.clickEvent && (e.clickEvent.comp || e.clickEvent.event)) n += 1;
  const videos = asList(e.instructionDatas);
  videos.forEach((item) => {
    n += asList(item && item.instructions).length;
  });
  return n;
}

export function componentLinkCount(comp) {
  if (!comp || !comp.componentLinks) return 0;
  return asList(comp.componentLinks.links).filter((l) => l && l.comp).length;
}

export function hasCanvasBind(comp) {
  return networkBindCount(comp) + eventBindCount(comp) + componentLinkCount(comp) > 0;
}

export function eventItemSummary(comp, key, ctx) {
  ctx = ctx || {};
  const events = (comp && comp.events) || {};
  const list = asList(events[key]);
  if (!list.length) {
    return { count: 0, text: "未设置", set: false };
  }
  if (key === "jumpEvent") {
    const name = pageNameFromStore(list[0], ctx.canvasAllData, ctx.pageOptions);
    return { count: 1, text: "跳转 → " + name, set: true };
  }
  if (key === "mutuallyEvent") {
    const btns = collectButtons(ctx.componentData, []);
    const names = list
      .map((id) => {
        const b = btns.find((x) => String(x.id) === String(id));
        return buttonNameOf(b) || String(id);
      })
      .filter(Boolean);
    const preview = names.slice(0, 2).join("、");
    const extra = names.length > 2 ? " 等" + names.length + "个" : "";
    return {
      count: list.length,
      text: preview ? "互斥：" + preview + extra : "已选 " + list.length + " 个按钮",
      set: true,
    };
  }
  if (key === "pressEvent" || key === "pressAgainEvent") {
    const names = list.map((item) => {
      const status = String(item.status) === "1" ? "按压" : "初始";
      return (item.buttonName || "按钮") + "→" + status;
    });
    const preview = names.slice(0, 2).join("；");
    const extra = names.length > 2 ? " 等" + names.length + "项" : "";
    return { count: list.length, text: preview + extra, set: true };
  }
  return { count: list.length, text: "已配置 " + list.length + " 项", set: true };
}

export function clickBindSummary(comp, ctx) {
  ctx = ctx || {};
  const ev = comp && comp.events && comp.events.clickEvent;
  if (!ev || !ev.comp) {
    return { set: false, text: "未设置" };
  }
  const list = asList(ctx.componentData);
  const target = list.find((c) => String(c.id) === String(ev.comp));
  const name = (target && (target.label || target.propValue)) || "组件";
  const action = ev.event || "未选事件";
  return { set: true, text: "点击 → " + name + "「" + action + "」" };
}
